var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-navbar",class:("navbar--" + (_vm.$store.state.navbarClassStyle))},[_c('Topbar'),_c('NavMenu'),_c('ProductSelect')],1)}
var staticRenderFns = []

export { render, staticRenderFns }